import { MEMBRESIAS } from '../actions/types';

const initialState = {
    listado: []
};

export default (state = initialState, action) => {
    const { type, payload } = action;

    switch(type) {
        case MEMBRESIAS.BUSCAR:
            return {
                ...state,
                listado: payload
            };

        default:
            return state;
    }
}
